// The Business Performance guide (12_SalesReportDashboard.jsx · ModuleHelp, Max 01/11).
const en = {
  reportT: 'Pick the report',
  reportB: 'Weekly, Weekly 2, Monthly and Weekly Flash are the sales reports; Inventory, Marketing and Pole Inventory appear when your role may see them. Everything below follows this choice.',
  periodT: 'Period and currency',
  periodB: 'Set Year, Month, Quarter, Week and Currency. Some of them are greyed out when the chosen report does not use them.',
  optionsT: 'What to count',
  optionsB: 'Tick to leave out distributors, include overseas or internal sales, run the report automatically after each change, or show the charts above the tables.',
  actionsT: 'Refresh, export, clear',
  actionsB: 'Refresh loads the report with your filters. Once it is loaded you can export it to PDF or Excel, and Clear filters puts everything back to the default.',
  tablesT: 'The report',
  tablesB: 'The tables are below, with an AI summary on Weekly and Monthly. Scroll sideways inside the report for the wider columns.',
};
const ko = {
  reportT: '리포트 선택',
  reportB: 'Weekly, Weekly 2, Monthly, Weekly Flash는 판매 리포트이고, Inventory, Marketing, Pole Inventory는 권한이 있을 때 나타납니다. 아래 화면은 모두 이 선택을 따릅니다.',
  periodT: '기간과 통화',
  periodB: 'Year, Month, Quarter, Week, Currency를 설정합니다. 선택한 리포트에서 쓰지 않는 항목은 회색으로 비활성화됩니다.',
  optionsT: '집계 범위',
  optionsB: '체크하면 distributor를 제외하거나 해외·내부 판매를 포함하고, 변경할 때마다 자동으로 실행하거나, 표 위에 차트를 보여줍니다.',
  actionsT: '새로고침, 내보내기, 초기화',
  actionsB: 'Refresh는 선택한 필터로 리포트를 불러옵니다. 불러온 뒤에는 PDF나 Excel로 내보낼 수 있고, 필터 지우기는 기본값으로 되돌립니다.',
  tablesT: '리포트',
  tablesB: '표는 아래에 있으며 Weekly와 Monthly에는 AI 요약이 함께 나옵니다. 넓은 열은 리포트 안에서 좌우로 스크롤해 확인하세요.',
};
const vi = {
  reportT: 'Chọn báo cáo',
  reportB: 'Weekly, Weekly 2, Monthly và Weekly Flash là các báo cáo doanh số; Inventory, Marketing và Pole Inventory chỉ hiện khi role của bạn được xem. Mọi thứ bên dưới đều theo lựa chọn này.',
  periodT: 'Kỳ và tiền tệ',
  periodB: 'Đặt Year, Month, Quarter, Week và Currency. Ô nào báo cáo đang chọn không dùng sẽ bị làm mờ.',
  optionsT: 'Tính những gì',
  optionsB: 'Tick để loại distributor, tính thêm doanh số nước ngoài hoặc nội bộ, tự chạy báo cáo sau mỗi lần đổi, hoặc hiện biểu đồ phía trên các bảng.',
  actionsT: 'Làm mới, xuất file, xóa lọc',
  actionsB: 'Refresh tải báo cáo theo bộ lọc của bạn. Khi đã tải, bạn có thể xuất ra PDF hoặc Excel, còn nút xóa lọc đưa mọi thứ về mặc định.',
  tablesT: 'Báo cáo',
  tablesB: 'Các bảng nằm bên dưới, kèm phần tóm tắt AI ở Weekly và Monthly. Cột nào rộng thì cuộn ngang trong báo cáo để xem.',
};
const zh = {
  reportT: '选择报表',
  reportB: 'Weekly、Weekly 2、Monthly 和 Weekly Flash 是销售报表；Inventory、Marketing 和 Pole Inventory 仅在您的角色有权限时显示。下方内容都跟随此选择。',
  periodT: '期间与币种',
  periodB: '设置 Year、Month、Quarter、Week 和 Currency。当前报表不使用的项目会显示为灰色。',
  optionsT: '统计范围',
  optionsB: '勾选后可排除 distributor、包含海外或内部销售、每次更改后自动运行报表，或在表格上方显示图表。',
  actionsT: '刷新、导出、清除',
  actionsB: 'Refresh 按您的筛选条件加载报表。加载后可导出为 PDF 或 Excel，清除筛选会恢复默认设置。',
  tablesT: '报表',
  tablesB: '表格在下方，Weekly 和 Monthly 还带有 AI 摘要。较宽的列请在报表内左右滚动查看。',
};

const dictionary = { ns: 'tourBizPerf', en, ko, vi, zh };
export default dictionary;
